/**
 * PoppinPay API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import DeliveryAddressValidationResult from './DeliveryAddressValidationResult';

/**
* The DeliveryAddressValidateResultModel model module.
* @module model/DeliveryAddressValidateResultModel
* @version 1.0.0
*/
export default class DeliveryAddressValidateResultModel {
    /**
    * Constructs a new <code>DeliveryAddressValidateResultModel</code>.
    * @alias module:model/DeliveryAddressValidateResultModel
    * @class
    */

    constructor() {
        
        
        
    }

    /**
    * Constructs a <code>DeliveryAddressValidateResultModel</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/DeliveryAddressValidateResultModel} obj Optional instance to populate.
    * @return {module:model/DeliveryAddressValidateResultModel} The populated <code>DeliveryAddressValidateResultModel</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new DeliveryAddressValidateResultModel();
                        
            
            if (data.hasOwnProperty('Results')) {
                obj['Results'] = ApiClient.convertToType(data['Results'], [DeliveryAddressValidationResult]);
            }
        }
        return obj;
    }

    /**
    * @member {Array.<module:model/DeliveryAddressValidationResult>} Results
    */
    'Results' = undefined;




}
